import React from 'react';
import { Skeleton } from 'antd';
import { useLazyImage } from '../../hooks/useLazyImage';

interface LazyPackImageProps {
  productId: string;
  packName: string;
  children: React.ReactNode;
}

const LazyPackImage: React.FC<LazyPackImageProps> = ({ 
  productId, 
  packName, 
  children 
}) => {
  const { imgRef, imageSrc, isLoading } = useLazyImage({
    src: `https://sabily.fr/wp-content/uploads/${productId}.png`,
    fallbackSrc: 'https://sabily.fr/wp-content/uploads/Defaut-2-1.jpg'
  });

  return (
    <div 
      ref={imgRef}
      style={{
        backgroundImage: `url("${imageSrc}")`,
        backgroundSize: 'cover', 
        backgroundPosition: 'center',
        height: '200px',
        position: 'relative'
      }}
    >
      {isLoading && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Skeleton.Image style={{ width: '100%', height: '200px' }} />
        </div>
      )}
      {children}
    </div>
  );
};

export default LazyPackImage;